import React from 'react';
import BlockContentDrawer from '../components/BlockContentDrawer';
import { useBlockContentMutation } from '../graphql/blockContent';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
export default function useBlockContent(...args) {
    const [blockContentMutationState, blockContentMutationActions] = useBlockContentMutation(...args);
    const block = (entity) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(BlockContentDrawer, { onConfirm: () => {
                    bottomDrawerHelperActions.hide();
                    blockContentMutationActions.submit({
                        variables: {
                            entity,
                        },
                    });
                } })),
        });
    };
    return [blockContentMutationState, { block }];
}
